import * as THREE from 'three';
import { ScenesManager } from '../ScenesManager';
import FireSparkShader from '../shaders/FireSpark';

export default class FireSpark extends THREE.Group {
	uniforms: { noiseTexture: { value: THREE.Texture; }; iTime: { value: number; }; iResolution: { value: THREE.Vector3; }; };
	globe: THREE.Mesh<THREE.SphereGeometry, THREE.ShaderMaterial, THREE.Object3DEventMap>;
	constructor() {
		super();
		this.name = "FireSpark"

		this.renderOrder = 2;
		this.uniforms = {
			noiseTexture: {value: ScenesManager.assets.fireSparkNoise},
			iTime: { value: 0 },
			iResolution:  { value: new THREE.Vector3(window.innerWidth, window.innerHeight, 1) },
		};

		const material = new THREE.ShaderMaterial({
			uniforms: this.uniforms,
			vertexShader: FireSparkShader.vertexShader,			
			fragmentShader: FireSparkShader.fragmentShader,				
			side: THREE.DoubleSide,
			blending: THREE.AdditiveBlending,
			transparent: true,			
		});

		const sphereGeometry = new THREE.SphereGeometry(50, 32, 32);
		this.globe = new THREE.Mesh(
			sphereGeometry,
			material
		)
		// this.globe.layers.enable( ScenesManager.BLOOM_SCENE )

		this.add(this.globe);
	}

	update(time: number) {
		this.uniforms.iTime.value = time;
	}
}